(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/form-field", [], factory);
	else if(typeof exports === 'object')
		exports["form-field"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["form-field"] = factory();
})(this, function() {
return 